// extracted by mini-css-extract-plugin
export default {"boxDescription":"BoxDescription_boxDescription__nB6T3"};